import React from "react";
import { fetchOne } from "../utils/fetchResources";
import { Link } from "react-router-dom";
import { SiteContext } from "../contexts/SiteContext";
import {
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  Divider,
} from "@material-ui/core";

const fullName = (person) => {
  let name = "";
  if (person.firstName) {
    name += person.firstName;
  }
  if (person.middleName) {
    name += " " + person.middleName;
  }
  if (person.lastName) {
    name += " " + person.lastName;
  }
  if (person.suffix) {
    name += " " + person.suffix;
  }
  return name.trim();
};

function PersonResult({ result, index }) {
  const { selectedSite } = React.useContext(SiteContext);
  const [file, setFile] = React.useState();
  const [loading, setLoading] = React.useState(true);

  // Support both ES-shaped hits (_source) and plain Mongo docs
  const doc = result && result._source ? result._source : result;

  React.useEffect(() => {
    if (doc && doc.featuredImage) {
      fetchOne("files", doc.featuredImage, setFile);
    }
    setLoading(false);
  }, [result]); // re-run if result changes

  if (loading || !doc || !selectedSite) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <ListItem
        component={Link}
        to={`/${selectedSite.slug}/people/${doc.slug || doc._id}`}
        key={index}
      >
        <ListItemAvatar>
          <Avatar
            alt="Person Thumbnail"
            src={
              file && `${process.env.REACT_APP_FILE_URL}/${file.thumbnailName}`
            }
            style={{ height: "75px", width: "75px", marginRight: "1rem" }}
            variant="rounded"
          >
            P
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={
            <>
              <Typography
                style={{ display: "inline" }}
                component="span"
                variant="h6"
                color="primary"
              >
                Person
              </Typography>
            </>
          }
          secondary={
            <>
              <Typography
                style={{ display: "inline" }}
                component="span"
                color="text.primary"
              >
                {fullName(doc)}
              </Typography>
            </>
          }
        />
      </ListItem>
      <Divider component="li" />
    </>
  );
}

export default PersonResult;

